// Hero slideshow slider js

document.addEventListener('DOMContentLoaded', function () {
  var herosliderSwipers = [];

  function initherosliderSwiper(swiperContainer) {
      var autoplay = swiperContainer.dataset.autoplay === "true";
      var loop = swiperContainer.dataset.loop === "true";
      var speed = swiperContainer.dataset.speed;
      var slider = swiperContainer.dataset.slider;

      var herosliderSwiper = new Swiper(swiperContainer, {
          slidesPerView: 1,
          spaceBetween: 0,
          loop: loop,
          autoplay: autoplay,
          speed: speed,
          grabCursor: true,
          navigation: {
              nextEl: swiperContainer.querySelector(".hero-slideshow-slider-swiper-button-next"),
              prevEl: swiperContainer.querySelector(".hero-slideshow-slider-swiper-button-prev")
          },
          pagination: {
              el: swiperContainer.querySelector(".hero-slideshow-slider-swiper-pagination"),
              clickable: true,
          }
      });

      herosliderSwipers.push(herosliderSwiper);
  }

  // Initialize Hero slider Swiper on page load
  document.querySelectorAll('.hero-slideshow-slider').forEach(function (swiperContainer) {
      initherosliderSwiper(swiperContainer);
  });

  document.addEventListener('shopify:section:select', function () {
      // Reinitialize Hero slider Swiper on section select
      herosliderSwipers.forEach(function (swiper) {
          swiper.destroy();
      });
      herosliderSwipers = [];
      document.querySelectorAll('.hero-slideshow-slider').forEach(function (swiperContainer) {
          initherosliderSwiper(swiperContainer);
      });
  });

  document.addEventListener('shopify:section:deselect', function () {
      // Cleanup Hero slider Swiper on section deselect if necessary
      herosliderSwipers.forEach(function (swiper) {
          swiper.destroy();
      });
      herosliderSwipers = [];
  });
});

// featured collection slider js

document.addEventListener('DOMContentLoaded', function () {
  var FeaturedcollectionSwipers = [];

  function initFeaturedcollectionSwiper(swiperContainer) {
      var enable = swiperContainer.dataset.enable;
      var desktopspace = swiperContainer.dataset.desktopspace;
      var mobilespace = swiperContainer.dataset.mobilespace;
      var desktop = swiperContainer.dataset.desktop;
      var largeTablet = swiperContainer.dataset.largetablet;
      var tablet = swiperContainer.dataset.tablet;
      var mobile = swiperContainer.dataset.mobile;
      var autoplay = swiperContainer.dataset.autoplay;
      var loop = swiperContainer.dataset.loop;
      var speed = swiperContainer.dataset.speed;

    if (enable) {
      var FeaturedcollectionSwiper = new Swiper(swiperContainer, {
          slidesPerView: desktop,
          spaceBetween: desktopspace,
          loop: loop,
          autoplay: autoplay,
          speed: speed,
          grabCursor: true,
          a11y: false,
          navigation: {
              nextEl: swiperContainer.querySelector(".featured-swiper-button-next"),
              prevEl: swiperContainer.querySelector(".featured-swiper-button-prev")
          },
          pagination: {
              el: swiperContainer.querySelector(".featured-swiper-pagination"),
              clickable: true,
          },
          breakpoints: {
            320: {
                slidesPerView: mobile,
                spaceBetween: mobilespace
            },
            576: {
                slidesPerView: tablet,
                spaceBetween: mobilespace
            },
            768: {
                slidesPerView: largeTablet,
                spaceBetween: mobilespace
            },
            992: {
                slidesPerView: desktop,
                spaceBetween: desktopspace
            },
        },
      });
    }
  }

  // Initialize Featured collection Swiper on page load
  document.querySelectorAll('.featured-slider').forEach(function (swiperContainer) {
      initFeaturedcollectionSwiper(swiperContainer);
  });

  document.addEventListener('shopify:section:select', function () {
      // Reinitialize Featured collection Swiper on section select
      FeaturedcollectionSwipers.forEach(function (swiper) {
          swiper.destroy();
      });
      FeaturedcollectionSwipers = [];
      document.querySelectorAll('.featured-slider').forEach(function (swiperContainer) {
          initFeaturedcollectionSwiper(swiperContainer);
      });
  });

  document.addEventListener('shopify:section:deselect', function () {
      // Cleanup Featured collection Swiper on section deselect if necessary
      FeaturedcollectionSwipers.forEach(function (swiper) {
          swiper.destroy();
      });
      FeaturedcollectionSwipers = [];
  });
});

// blog slider js

document.addEventListener('DOMContentLoaded', function () {
  var FeaturedblogSwipers = [];

  function initFeaturedblogSwiper(swiperContainer) {
      var desktopspace = swiperContainer.dataset.desktopspace;
      var mobilespace = swiperContainer.dataset.mobilespace;
      var autoplay = swiperContainer.dataset.autoplay;
      var loop = swiperContainer.dataset.loop;
      var speed = swiperContainer.dataset.speed;
  
      var FeaturedblogSwiper = new Swiper(swiperContainer, {
          slidesPerView: 1,
          spaceBetween: desktopspace,
          loop: loop,
          autoplay: autoplay,
          speed: speed,
          grabCursor: true,
          a11y: false,
          navigation: {
              nextEl: swiperContainer.querySelector(".blog-swiper-button-next"),
              prevEl: swiperContainer.querySelector(".blog-swiper-button-prev")
          },
          pagination: {
              el: swiperContainer.querySelector(".blog-swiper-pagination"),
              clickable: true,
          },
          breakpoints: {
            320: {
                slidesPerView: 1,
                spaceBetween: mobilespace
            },
            576: {
                slidesPerView: 2,
                spaceBetween: mobilespace
            },
            768: {
                slidesPerView: 2.5,
                spaceBetween: mobilespace
            },
            992: {
                slidesPerView: 1,
                spaceBetween: desktopspace
            },
          },
      });

      FeaturedblogSwipers.push(FeaturedblogSwiper);
  }

  // Initialize Featured blog Swiper on page load
  document.querySelectorAll('.blog-slider').forEach(function (swiperContainer) {
      initFeaturedblogSwiper(swiperContainer);
  });

  document.addEventListener('shopify:section:select', function () {
      // Reinitialize Featured blog Swiper on section select
      FeaturedblogSwipers.forEach(function (swiper) {
          swiper.destroy();
      });
      FeaturedblogSwipers = [];
      document.querySelectorAll('.blog-slider').forEach(function (swiperContainer) {
          initFeaturedblogSwiper(swiperContainer);
      });
  });

  document.addEventListener('shopify:section:deselect', function () {
      // Cleanup Featured blog Swiper on section deselect if necessary
      FeaturedblogSwipers.forEach(function (swiper) {
          swiper.destroy();
      });
      FeaturedblogSwipers = [];
  });
});

// Event slider js

document.addEventListener('DOMContentLoaded', function () {
    var EventSwipers = [];

    function initEventSwiper(swiperContainer) {
        var desktopspace = swiperContainer.dataset.desktopspace;
        var mobilespace = swiperContainer.dataset.mobilespace;
        var desktop = swiperContainer.dataset.desktop;
        var largeTablet = swiperContainer.dataset.largetablet;
        var tablet = swiperContainer.dataset.tablet;
        var mobile = swiperContainer.dataset.mobile;
        var autoplay = swiperContainer.dataset.autoplay;
        var loop = swiperContainer.dataset.loop;
        var speed = swiperContainer.dataset.speed;

        var EventSwiper = new Swiper(swiperContainer, {
            slidesPerView: 1,
            spaceBetween: desktopspace,
            loop: loop,
            autoplay: autoplay,
            speed: speed,
            grabCursor: true,
            a11y: false,
            navigation: {
                nextEl: swiperContainer.querySelector(".events-swiper-button-next"),
                prevEl: swiperContainer.querySelector(".events-swiper-button-prev")
            }
        });

        EventSwipers.push(EventSwiper);
    }

    document.querySelectorAll('.events-main-slider-part').forEach(function (swiperContainer) {
        initEventSwiper(swiperContainer);
    });

    document.addEventListener('shopify:section:select', function () {
        EventSwipers.forEach(function (swiper) {
            swiper.destroy(true, true);
        });
        EventSwipers = [];
        document.querySelectorAll('.events-main-slider-part').forEach(function (swiperContainer) {
            initEventSwiper(swiperContainer);
        });
    });

    document.addEventListener('shopify:section:deselect', function () {
        EventSwipers.forEach(function (swiper) {
            swiper.destroy(true, true);
        });
        EventSwipers = [];
    });
});

// multicolumn slider js

document.addEventListener('DOMContentLoaded', function () {
  var MulticolumnSwipers = [];

  function initmulticolumnSwiper(swiperContainer) {
      var desktop = swiperContainer.dataset.desktop;
      var largeTablet = swiperContainer.dataset.largetablet;
      var tablet = swiperContainer.dataset.tablet;
      var mobile = swiperContainer.dataset.mobile;
      var autoplay = swiperContainer.dataset.autoplay;
      var loop = swiperContainer.dataset.loop;
      var speed = swiperContainer.dataset.speed;

      var MulticolumnSwiper = new Swiper(swiperContainer, {
          slidesPerView: desktop,
          spaceBetween: 80,
          loop: loop,
          autoplay: autoplay,
          speed: speed,
          grabCursor: true,
          a11y: false,
          navigation: {
              nextEl: swiperContainer.querySelector(".multicolumn-swiper-button-next"),
              prevEl: swiperContainer.querySelector(".multicolumn-swiper-button-prev")
          },
          pagination: {
              el: swiperContainer.querySelector(".multicolumn-swiper-pagination"),
              clickable: true,
          },
          breakpoints: {
            320: {
                slidesPerView: mobile,
                spaceBetween: 20
            },
            576: {
                slidesPerView: tablet,
                spaceBetween: 20
            },
            768: {
                slidesPerView: largeTablet,
                spaceBetween: 40
            },
            992: {
                slidesPerView: desktop,
                spaceBetween: 60
            },
          },
      });

      MulticolumnSwipers.push(MulticolumnSwiper);
  }

  // Initialize Multicolumn Swiper on page load
  document.querySelectorAll('.multicolumn-slider').forEach(function (swiperContainer) {
      initmulticolumnSwiper(swiperContainer);
  });

  document.addEventListener('shopify:section:select', function () {
      // Reinitialize Multicolumn Swiper on section select
      MulticolumnSwipers.forEach(function (swiper) {
          swiper.destroy();
      });
      MulticolumnSwipers = [];
      document.querySelectorAll('.multicolumn-slider').forEach(function (swiperContainer) {
          initmulticolumnSwiper(swiperContainer);
      });
  });

  document.addEventListener('shopify:section:deselect', function () {
      // Cleanup Multicolumn Swiper on section deselect if necessary
      MulticolumnSwipers.forEach(function (swiper) {
          swiper.destroy();
      });
      MulticolumnSwipers = [];
  });
});

// recentview collection slider js

document.addEventListener('DOMContentLoaded', function () {
  var recentviewcollectionSwipers = [];

  function initrecentviewcollectionSwiper(swiperContainer) {
      var desktopspace = swiperContainer.dataset.desktopspace;
      var mobilespace = swiperContainer.dataset.mobilespace;
      var desktop = swiperContainer.dataset.desktop;
      var largeTablet = swiperContainer.dataset.largetablet;
      var tablet = swiperContainer.dataset.tablet;
      var mobile = swiperContainer.dataset.mobile;
      var autoplay = swiperContainer.dataset.autoplay;
      var loop = swiperContainer.dataset.loop;
      var speed = swiperContainer.dataset.speed;

      var recentviewcollectionSwiper = new Swiper(swiperContainer, {
          slidesPerView: desktop,
          spaceBetween: desktopspace,
          loop: loop,
          autoplay: autoplay,
          speed: speed,
          grabCursor: true,
          a11y: false,
          navigation: {
              nextEl: swiperContainer.querySelector(".recent-swiper-button-next"),
              prevEl: swiperContainer.querySelector(".recent-swiper-button-prev")
          },
          pagination: {
              el: swiperContainer.querySelector(".recent-swiper-pagination"),
              clickable: true,
          },
          breakpoints: {
            320: {
                slidesPerView: mobile,
                spaceBetween: mobilespace
            },
            576: {
                slidesPerView: tablet,
                spaceBetween: mobilespace
            },
            768: {
                slidesPerView: largeTablet,
                spaceBetween: mobilespace
            },
            992: {
                slidesPerView: desktop,
                spaceBetween: desktopspace
            },
        },
      });

      recentviewcollectionSwipers.push(recentviewcollectionSwiper);
  }

  // Initialize Featured collection Swiper on page load
  document.querySelectorAll('.recent-slider').forEach(function (swiperContainer) {
      initrecentviewcollectionSwiper(swiperContainer);
  });

  document.addEventListener('shopify:section:select', function () {
      // Reinitialize Featured collection Swiper on section select
      recentviewcollectionSwipers.forEach(function (swiper) {
          swiper.destroy();
      });
      recentviewcollectionSwipers = [];
      document.querySelectorAll('.recent-slider').forEach(function (swiperContainer) {
          initrecentviewcollectionSwiper(swiperContainer);
      });
  });

  document.addEventListener('shopify:section:deselect', function () {
      // Cleanup Featured collection Swiper on section deselect if necessary
      recentviewcollectionSwipers.forEach(function (swiper) {
          swiper.destroy();
      });
      recentviewcollectionSwipers = [];
  });
});

// Aboutus Style1 slider js

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.about_style1').forEach(function (section) {

    let leftSlider = section.querySelector('.about_style1-left-slider');
    let contentSlider = section.querySelector('.about_style1-content-slider');
    let imageSlider = section.querySelector('.about_style1-image-slider');
    let slideNumbers = section.querySelectorAll('.about_style1-slide-number');

    function updateSlideNumbers(index) {
      slideNumbers.forEach(function (number, i) {
        if (i === index) {
          number.classList.add('active');
        } else {
          number.classList.remove('active');
        }
      });
    }

    let leftSwiper = new Swiper(leftSlider, {
      slidesPerView: 1,
      spaceBetween: 0,
      loop: false,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
      speed: 1500,
      grabCursor: true,
      a11y: false,
    });

    let contentSwiper = new Swiper(contentSlider, {
      slidesPerView: 1,
      spaceBetween: 0,
      loop: false,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
      speed: 1500,
      effect: 'fade',
      fadeEffect: {
        crossFade: true,
      },
      grabCursor: true,
      a11y: false,
    });

    let imageSwiper = new Swiper(imageSlider, {
      slidesPerView: 1,
      spaceBetween: 0,
      loop: false,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
      speed: 1500,
      grabCursor: true,
      a11y: false,
    });

    leftSwiper.on('slideChange', function () {
      contentSwiper.slideTo(leftSwiper.activeIndex);
      imageSwiper.slideTo(leftSwiper.activeIndex);
      updateSlideNumbers(leftSwiper.activeIndex);
    });

    contentSwiper.on('slideChange', function () {
      leftSwiper.slideTo(contentSwiper.activeIndex);
      imageSwiper.slideTo(contentSwiper.activeIndex);
      updateSlideNumbers(contentSwiper.activeIndex);
    });

    imageSwiper.on('slideChange', function () {
      leftSwiper.slideTo(imageSwiper.activeIndex);
      contentSwiper.slideTo(imageSwiper.activeIndex);
      updateSlideNumbers(imageSwiper.activeIndex);
    });

    // Pagination click
    slideNumbers.forEach(function (number, index) {
      number.addEventListener('click', function () {

        leftSwiper.slideTo(index);
        contentSwiper.slideTo(index);
        imageSwiper.slideTo(index);

        updateSlideNumbers(index);
      });
    });

    updateSlideNumbers(0);
  });
});

// Aboutus Style2 slider js

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.about_style2').forEach(function (section) {
    let leftSlider = section.querySelector('.about_style2-left-slider');
    let contentSlider = section.querySelector('.about_style2-content-slider');

    let nextBtn = section.querySelector('.about_style2-swiper-button-next');
    let prevBtn = section.querySelector('.about_style2-swiper-button-prev');
    let pagination = section.querySelector('.about_style2-swiper-pagination');

    let leftSwiper = new Swiper(leftSlider, {
      slidesPerView: 1,
      spaceBetween: 0,
      loop: false,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
      speed: 800,
      grabCursor: true,
      a11y: false,
      navigation: {
        nextEl: nextBtn,
        prevEl: prevBtn,
      },
      pagination: {
        el: pagination,
        clickable: true,
      },
    });

    let contentSwiper = new Swiper(contentSlider, {
      slidesPerView: 1,
      spaceBetween: 0,
      loop: false,
      speed: 800,
      effect: 'fade',
      fadeEffect: {
        crossFade: true,
      },
      allowTouchMove: false,
      simulateTouch: false,
      a11y: false,
    });

    leftSwiper.on('slideChange', function () {
      contentSwiper.slideTo(leftSwiper.activeIndex);
    });
  });
});

// Aboutus Style3 slider js

document.addEventListener('DOMContentLoaded', function () {
  var AboutusStyle3Swipers = [];

  function initAboutusStyle3Swiper(swiperContainer) {
      var AboutusStyle3Swiper = new Swiper(swiperContainer, {
          slidesPerView: 1,
          spaceBetween: 0,
          loop: true,
          autoplay: true,
          speed: 500,
          grabCursor: true,
          a11y: false,
          navigation: false,
          pagination: {
              el: swiperContainer.querySelector(".aboutus-style3-swiper-pagination"),
              clickable: true,
          },
          breakpoints: {
            320: {
                slidesPerView: 1,
                spaceBetween: 0
            },
            576: {
                slidesPerView: 1,
                spaceBetween: 0
            },
            768: {
                slidesPerView: 1,
                spaceBetween: 0
            },
            992: {
                slidesPerView: 1,
                spaceBetween: 0
            },
          },
      });
  }

  // Initialize Aboutus style1 Swiper on page load
  document.querySelectorAll('.aboutus-style3-slider').forEach(function (swiperContainer) {
      initAboutusStyle3Swiper(swiperContainer);
  });

  document.addEventListener('shopify:section:select', function () {
      // Reinitialize Aboutus style1 Swiper on section select
      AboutusStyle3Swipers.forEach(function (swiper) {
          swiper.destroy();
      });
      AboutusStyle3Swipers = [];
      document.querySelectorAll('.aboutus-style3-slider').forEach(function (swiperContainer) {
          initAboutusStyle3Swiper(swiperContainer);
      });
  });

  document.addEventListener('shopify:section:deselect', function () {
      // Cleanup Aboutus style1 Swiper on section deselect if necessary
      AboutusStyle3Swipers.forEach(function (swiper) {
          swiper.destroy();
      });
      AboutusStyle3Swipers = [];
  });
});

// Gallery slider js

document.addEventListener('DOMContentLoaded', function () {
  var GallerySwipers = [];

  function initGallerySwiper(swiperContainer) {
      var desktopspace = swiperContainer.dataset.desktopspace;
      var mobilespace = swiperContainer.dataset.mobilespace;
      var desktop = swiperContainer.dataset.desktop;
      var largeTablet = swiperContainer.dataset.largetablet;
      var tablet = swiperContainer.dataset.tablet;
      var mobile = swiperContainer.dataset.mobile;
      var autoplay = swiperContainer.dataset.autoplay;
      var loop = swiperContainer.dataset.loop;
      var speed = swiperContainer.dataset.speed;

      var GallerySwiper = new Swiper(swiperContainer, {
          slidesPerView: desktop,
          spaceBetween: desktopspace,
          centeredSlides: false,
          loop: loop,
          autoplay: autoplay,
          speed: speed,
          grabCursor: true,
          a11y: false,
          navigation: {
              nextEl: swiperContainer.querySelector(".gallery-swiper-button-next"),
              prevEl: swiperContainer.querySelector(".gallery-swiper-button-prev")
          },
          pagination: {
              el: swiperContainer.querySelector(".gallery-swiper-pagination"),
              clickable: true,
          },
          breakpoints: {
              320: {
                  slidesPerView: mobile,
                  spaceBetween: mobilespace,
                  centeredSlides: true
              },
              576: {
                  slidesPerView: tablet,
                  spaceBetween: mobilespace
              },
              768: {
                  slidesPerView: largeTablet,
                  spaceBetween: mobilespace

              },
              992: {
                  slidesPerView: desktop,
                  spaceBetween: desktopspace
              },
          },
      });
  }

  // Initialize Gallery Swiper on page load
  document.querySelectorAll('.gallery-slider').forEach(function (swiperContainer) {
      initGallerySwiper(swiperContainer);
  });

  document.addEventListener('shopify:section:select', function () {
      // Reinitialize Gallery Swiper on section select
      GallerySwipers.forEach(function (swiper) {
          swiper.destroy();
      });
      GallerySwipers = [];
      document.querySelectorAll('.gallery-slider').forEach(function (swiperContainer) {
          initGallerySwiper(swiperContainer);
      });
  });

  document.addEventListener('shopify:section:deselect', function () {
      // Cleanup Gallery Swiper on section deselect if necessary
      GallerySwipers.forEach(function (swiper) {
          swiper.destroy();
      });
      GallerySwipers = [];
  });
});

// Video with text slider js

document.addEventListener('DOMContentLoaded', function () {
  var VideoproductSwipers = [];

  function initVideoproductSwiper(swiperContainer) {
      var desktop = swiperContainer.dataset.desktop;
      var largeTablet = swiperContainer.dataset.largetablet;
      var tablet = swiperContainer.dataset.tablet;
      var mobile = swiperContainer.dataset.mobile;
      var autoplay = swiperContainer.dataset.autoplay;
      var loop = swiperContainer.dataset.loop;
      var speed = swiperContainer.dataset.speed;

      var VideoproductSwiper = new Swiper(swiperContainer, {
          slidesPerView: desktop,
          spaceBetween: 80,
          centeredSlides: false,
          loop: loop,
          autoplay: autoplay,
          speed: speed,
          grabCursor: true,
          a11y: false,
          navigation: {
              nextEl: swiperContainer.querySelector(".videoproduct-swiper-button-next"),
              prevEl: swiperContainer.querySelector(".videoproduct-swiper-button-prev")
          },
          pagination: {
              el: swiperContainer.querySelector(".videoproduct-swiper-pagination"),
              clickable: true,
          },
          breakpoints: {
            320: {
                slidesPerView: mobile,
                spaceBetween: 20,
                centeredSlides: true
            },
            576: {
                slidesPerView: tablet,
                spaceBetween: 20
            },
            768: {
                slidesPerView: largeTablet,
                spaceBetween: 40
            },
            992: {
                slidesPerView: desktop,
                spaceBetween: 60
            },
        },
      });
  }

  // Initialize Videoproduct collection Swiper on page load
  document.querySelectorAll('.video-product-slider').forEach(function (swiperContainer) {
      initVideoproductSwiper(swiperContainer);
  });

  document.addEventListener('shopify:section:select', function () {
      // Reinitialize Videoproduct collection Swiper on section select
      VideoproductSwipers.forEach(function (swiper) {
          swiper.destroy();
      });
      VideoproductSwipers = [];
      document.querySelectorAll('.video-product-slider').forEach(function (swiperContainer) {
          initVideoproductSwiper(swiperContainer);
      });
  });

  document.addEventListener('shopify:section:deselect', function () {
      // Cleanup Videoproduct collection Swiper on section deselect if necessary
      VideoproductSwipers.forEach(function (swiper) {
          swiper.destroy();
      });
      VideoproductSwipers = [];
  });
});

// Image with text slider js

document.addEventListener('DOMContentLoaded', function () {
  var ImagewithTextSwipers = [];

  function initImagewithTextSwiper(swiperContainer) {
      var desktop = swiperContainer.dataset.desktop;
      var largeTablet = swiperContainer.dataset.largetablet;
      var tablet = swiperContainer.dataset.tablet;
      var mobile = swiperContainer.dataset.mobile;
      var autoplay = swiperContainer.dataset.autoplay === "true";
      var loop = swiperContainer.dataset.loop === "true";
      var speed = swiperContainer.dataset.speed;

      var ImagewithTextSwiper = new Swiper(swiperContainer, {
          slidesPerView: desktop,
          spaceBetween: 20,
          centeredSlides: false,
          loop: loop,
          autoplay: autoplay,
          speed: speed,
          grabCursor: true,
          a11y: false,
          navigation: {
              nextEl: swiperContainer.querySelector(".image-with-text-swiper-button-next"),
              prevEl: swiperContainer.querySelector(".image-with-text-swiper-button-prev")
          },
          pagination: {
              el: swiperContainer.querySelector(".image-with-text-swiper-pagination"),
              clickable: true,
          },
          breakpoints: {
            320: {
                slidesPerView: mobile,
                spaceBetween: 10,
                centeredSlides: true
            },
            576: {
                slidesPerView: tablet,
                spaceBetween: 10
            },
            768: {
                slidesPerView: largeTablet,
                spaceBetween: 20
            },
            992: {
                slidesPerView: desktop,
                spaceBetween: 20
            },
        },
      });
  }

  // Initialize ImagewithText collection Swiper on page load
  document.querySelectorAll('.image-with-text-slider').forEach(function (swiperContainer) {
      initImagewithTextSwiper(swiperContainer);
  });

  document.addEventListener('shopify:section:select', function () {
      // Reinitialize ImagewithText collection Swiper on section select
      ImagewithTextSwipers.forEach(function (swiper) {
          swiper.destroy();
      });
      ImagewithTextSwipers = [];
      document.querySelectorAll('.image-with-text-slider').forEach(function (swiperContainer) {
          initImagewithTextSwiper(swiperContainer);
      });
  });

  document.addEventListener('shopify:section:deselect', function () {
      // Cleanup ImagewithText collection Swiper on section deselect if necessary
      ImagewithTextSwipers.forEach(function (swiper) {
          swiper.destroy();
      });
      ImagewithTextSwipers = [];
  });
});

// Team member slider js

document.addEventListener('DOMContentLoaded', function () {
  var TeammemberSwipers = [];

  function initTeammemberSwiper(swiperContainer) {
      var desktopspace = swiperContainer.dataset.desktopspace;
      var mobilespace = swiperContainer.dataset.mobilespace;
      var desktop = swiperContainer.dataset.desktop;
      var largeTablet = swiperContainer.dataset.largetablet;
      var tablet = swiperContainer.dataset.tablet;
      var mobile = swiperContainer.dataset.mobile;
      var autoplay = swiperContainer.dataset.autoplay;
      var loop = swiperContainer.dataset.loop;
      var speed = swiperContainer.dataset.speed;

      var TeammemberSwiper = new Swiper(swiperContainer, {
          slidesPerView: desktop,
          spaceBetween: desktopspace,
          loop: loop,
          autoplay: autoplay,
          speed: speed,
          grabCursor: true,
          a11y: false,
          navigation: {
              nextEl: swiperContainer.querySelector(".team-member-swiper-button-next"),
              prevEl: swiperContainer.querySelector(".team-member-swiper-button-prev")
          },
          pagination: {
              el: swiperContainer.querySelector(".team-member-swiper-pagination"),
              clickable: true,
          },
          breakpoints: {
            320: {
                slidesPerView: mobile,
                spaceBetween: mobilespace
            },
            576: {
                slidesPerView: tablet,
                spaceBetween: mobilespace
            },
            768: {
                slidesPerView: largeTablet,
                spaceBetween: mobilespace
            },
            992: {
                slidesPerView: desktop,
                spaceBetween: desktopspace
            },
        },
      });
  }

  // Initialize Teammember collection Swiper on page load
  document.querySelectorAll('.team-member-slider').forEach(function (swiperContainer) {
      initTeammemberSwiper(swiperContainer);
  });

  document.addEventListener('shopify:section:select', function () {
      // Reinitialize Teammember collection Swiper on section select
      TeammemberSwipers.forEach(function (swiper) {
          swiper.destroy();
      });
      TeammemberSwipers = [];
      document.querySelectorAll('.team-member-slider').forEach(function (swiperContainer) {
          initTeammemberSwiper(swiperContainer);
      });
  });

  document.addEventListener('shopify:section:deselect', function () {
      // Cleanup Teammember collection Swiper on section deselect if necessary
      TeammemberSwipers.forEach(function (swiper) {
          swiper.destroy();
      });
      TeammemberSwipers = [];
  });
});

// Brand section style2 slider js

document.addEventListener('DOMContentLoaded', function () {
  var BrandSectionStyle2Swipers = [];

  function initBrandSectionStyle2Swiper(swiperContainer) {
      var desktopspace = swiperContainer.dataset.desktopspace;
      var mobilespace = swiperContainer.dataset.mobilespace;
      var desktop = swiperContainer.dataset.desktop;
      var largeTablet = swiperContainer.dataset.largetablet;
      var tablet = swiperContainer.dataset.tablet;
      var mobile = swiperContainer.dataset.mobile;
      var autoplay = swiperContainer.dataset.autoplay;
      var loop = swiperContainer.dataset.loop;
      var speed = swiperContainer.dataset.speed;

      var BrandSectionStyle2Swiper = new Swiper(swiperContainer, {
          slidesPerView: desktop,
          spaceBetween: desktopspace,
          loop: loop,
          autoplay: autoplay,
          speed: speed,
          grabCursor: true,
          a11y: false,
          navigation: {
              nextEl: swiperContainer.querySelector(".brand-section-style2-swiper-button-next"),
              prevEl: swiperContainer.querySelector(".brand-section-style2-swiper-button-prev")
          },
          pagination: {
              el: swiperContainer.querySelector(".brand-section-style2-swiper-pagination"),
              clickable: true,
          },
          breakpoints: {
              320: {
                  slidesPerView: mobile,
                  spaceBetween: mobilespace
              },
              576: {
                  slidesPerView: tablet,
                  spaceBetween: mobilespace
              },
              768: {
                  slidesPerView: largeTablet,
                  spaceBetween: mobilespace
              },
              992: {
                  slidesPerView: desktop,
                  spaceBetween: desktopspace
              },
          },
      });

      BrandSectionStyle2Swipers.push(BrandSectionStyle2Swiper);
  }

  // Initialize Brand Section Style2 Swiper on page load
  document.querySelectorAll('.main-brand-post-section-style2-wrapper').forEach(function (swiperContainer) {
      initBrandSectionStyle2Swiper(swiperContainer);
  });

  document.addEventListener('shopify:section:select', function () {
      BrandSectionStyle2Swipers.forEach(function (swiper) {
          swiper.destroy();
      });
      BrandSectionStyle2Swipers = [];

      document.querySelectorAll('.main-brand-post-section-style2-wrapper').forEach(function (swiperContainer) {
          initBrandSectionStyle2Swiper(swiperContainer);
      });
  });

  document.addEventListener('shopify:section:deselect', function () {
      BrandSectionStyle2Swipers.forEach(function (swiper) {
          swiper.destroy();
      });
      BrandSectionStyle2Swipers = [];
  });
});

// Project section style2 slider js

document.addEventListener('DOMContentLoaded', function () {
  var ProjectSectionStyle2Swipers = [];

  function initProjectSectionStyle2Swiper(swiperContainer) {
      var desktopspace = swiperContainer.dataset.desktopspace;
      var mobilespace = swiperContainer.dataset.mobilespace;
      var desktop = swiperContainer.dataset.desktop;
      var largeTablet = swiperContainer.dataset.largetablet;
      var tablet = swiperContainer.dataset.tablet;
      var mobile = swiperContainer.dataset.mobile;
      var autoplay = swiperContainer.dataset.autoplay;
      var loop = swiperContainer.dataset.loop;
      var speed = swiperContainer.dataset.speed;

      var ProjectSectionStyle2Swiper = new Swiper(swiperContainer, {
          slidesPerView: desktop,
          spaceBetween: desktopspace,
          loop: loop,
          autoplay: autoplay,
          speed: speed,
          grabCursor: true,
          a11y: false,
          navigation: {
              nextEl: swiperContainer.querySelector(".project-section-style2-swiper-button-next"),
              prevEl: swiperContainer.querySelector(".project-section-style2-swiper-button-prev")
          },
          pagination: {
              el: swiperContainer.querySelector(".project-section-style2-swiper-pagination"),
              clickable: true,
          },
          breakpoints: {
              320: {
                  slidesPerView: mobile,
                  spaceBetween: mobilespace
              },
              576: {
                  slidesPerView: tablet,
                  spaceBetween: mobilespace
              },
              768: {
                  slidesPerView: largeTablet,
                  spaceBetween: mobilespace
              },
              992: {
                  slidesPerView: desktop,
                  spaceBetween: desktopspace
              },
          },
      });

      ProjectSectionStyle2Swipers.push(ProjectSectionStyle2Swiper);
  }

  // Initialize Brand Section Style2 Swiper on page load
  document.querySelectorAll('.main-project-section-style2-wrapper').forEach(function (swiperContainer) {
      initProjectSectionStyle2Swiper(swiperContainer);
  });

  document.addEventListener('shopify:section:select', function () {
      ProjectSectionStyle2Swipers.forEach(function (swiper) {
          swiper.destroy();
      });
      ProjectSectionStyle2Swipers = [];

      document.querySelectorAll('.main-project-section-style2-wrapper').forEach(function (swiperContainer) {
          initProjectSectionStyle2Swiper(swiperContainer);
      });
  });

  document.addEventListener('shopify:section:deselect', function () {
      ProjectSectionStyle2Swipers.forEach(function (swiper) {
          swiper.destroy();
      });
      ProjectSectionStyle2Swipers = [];
  });
});